import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchPlaceholder: {
		id: 'backlog.header.controls-bar.backlog-filter-refinement.search-placeholder',
		defaultMessage: 'Search backlog',
		description: 'Search field placeholder text for filter bar',
	},
});
